import { getMultiStepQuizV3Template, getVueMultiStepQuizV3 } from "../../shortcodes/templates";

let multiStepQuiz = null;
const visualizeMultiStepQuizV3 = content => {
  multiStepQuiz = content.querySelectorAll('[data-wrapper-id="multi-step-quiz-v3"]');

  if (multiStepQuiz.length > 0) {
    multiStepQuiz.forEach(item => {
      item.innerHTML = getMultiStepQuizV3Template();
    });
  }
};

const serializeMultiStepQuizV3 = content => {
  const multiStepQuizWidget = content.querySelectorAll('[data-wrapper-id="multi-step-quiz-v3"]');
  if (multiStepQuizWidget.length > 0) {
    multiStepQuizWidget.forEach(item => {
      const quizData = item.getAttribute("data-multi-step-quiz-data");
      item.innerHTML = getVueMultiStepQuizV3(quizData);
    });
  }
};

export { visualizeMultiStepQuizV3, serializeMultiStepQuizV3 };
